module.exports = __webpack_public_path__ + "static/media/IMG_20190826_180655.image.b8f08b0a.png";